/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_Prereq_2Inputs */

const en_directory_mcp_prereq_2 = /** @type {(inputs: Directory_Mcp_Prereq_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The token (sk_proj_…) arrives after approval and carries only the scopes the owner granted.`)
};

const zh_directory_mcp_prereq_2 = /** @type {(inputs: Directory_Mcp_Prereq_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`令牌（sk_proj_…）在批准后签发，只携带所有者授予的权限。`)
};

/**
* | output |
* | --- |
* | "The token (sk_proj_…) arrives after approval and carries only the scopes the owner granted." |
*
* @param {Directory_Mcp_Prereq_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_prereq_2 = /** @type {((inputs?: Directory_Mcp_Prereq_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_Prereq_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_prereq_2(inputs)
	return zh_directory_mcp_prereq_2(inputs)
});
export { directory_mcp_prereq_2 as "directory.mcp.prereq_2" }